// 订单中心->智能地址解析页面

import listeningToKeydownMixin from '@/assets/js/mixins/listeningToKeydown.js';

const areaList = require('@/assets/js/address/area-list.js');
const { parse, parseArea } = require('@/assets/js/address/address-parse.js');

parseArea(areaList);

export default {
  /* props: {
    componentData: {},
  }, */
  mixins: [listeningToKeydownMixin],
  components: {},
  data() {
    return {
      componentData: {},
      vmI18n: window.vmI18n,
      isWatchChange: false, // 监听是否手动修改
      isShowFromLoading: false, // 加载
      objId: -1,
      newReceivAddress: '',
      ReceivAddress: '', // 新地址
      ReceivProvince: '', // 省市区
      ReceivCity: '',
      ReceivArea: '',
      ReceivTown: '',
      ReceivProvinceName: '',
      ReceivCityName: '',
      ReceivAreaName: '',
      ReceivTownName: '',
      ReceivName: '', // 收货人
      ReceivMobile: '', // 手机号
      provList: [],
      cityList: [],
      areaList: [],
      parseAddressLoad: false,
      dataAysis: true, // 智能解析地址是否正确
      regx: {
        mobile: /^[\d\-]+$/,
        phone: /^\d{11,12}$/,
        shipamt: /^\d*(\.[0-9]{0,2})?$/,
        shipzip: /^\d{6}$/,
        number: '/^d?$/',
      },
      // 2019-8-12 去掉收货人的正则        name: /^[a-zA-Z_\u4e00-\u9fa5]+$/,
      data: {
        receiver_address: '',
        cp_c_region_province_id: '',
        cp_c_region_city_id: '',
        cp_c_region_area_id: '',
        cp_c_region_town_ename: '',
        receiver_name: '',
        receiver_mobile: '',
        receiver_phone: '',
        receiver_zip: '',
        ship_amt: '',
        platform_province: '',
        platform_city: '',
        platform_area: '',
        platform_town: '',
      }, // 需要提交的数据
      formConfig: {
        formData: [
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            itemdata: {
              col: 1,
              colid: 167814,
              colname: 'cp_c_region_province_id', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.dh'), // 省份
              inputname: 'CP_C_STORE_IDS:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: $it('fL.dh'), // 省份
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_PROVINCE', // 对应的表
              reftableid: 10010, // 对应的表ID
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              this.formConfig.formValue.cp_c_region_city_id = '';
              this.formConfig.formValue.cp_c_region_area_id = '';
              this.twoObjs(e);
            },
          },
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            itemdata: {
              col: 1,
              colid: 167815,
              colname: 'cp_c_region_city_id', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.consignee_city'), // 收货人市
              inputname: 'RECEIVER_CITY:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: '城市',
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_CITY', // 对应的表
              reftableid: 23864, // 对应的表ID
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'cp_c_region_province_id',
              },
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              this.formConfig.formValue.cp_c_region_area_id = '';
              this.twoObjs(e);
            },
          },
          {
            style: 'dropSelect', // 输入框弹框单多选
            width: '6',
            itemdata: {
              col: 1,
              colid: 167816,
              colname: 'cp_c_region_area_id', // 当前字段的名称
              datelimit: 'all',
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              fkdesc: $it('fL.aconsignee_area'), // 收货人区
              inputname: 'RECEIVER_AREA:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 65535, // 最大长度是多少
              name: '区县',
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: 'CP_C_DISTAREA', // 对应的表
              reftableid: 23863, // 对应的表ID
              row: 1,
              statsize: -1,
              type: 'STRING', // 这个是后台用的
              pid: '',
              valuedata: '', // 这个是选择的值
              refcolval: {
                fixcolumn: 'C_UP_ID',
                expre: 'equal',
                srccol: 'cp_c_region_city_id',
              }, // 过滤配置
            },
            oneObj: (e) => {
              this.twoObjs(e);
            },
          },
          {
            style: 'input',
            label: '街道/乡镇',
            value: 'cp_c_region_town_ename',
            disabled: false,
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.ab'), // 详细地址
            value: 'receiver_address',
            disabled: false,
            width: '24',
          },
          {
            style: 'input',
            label: $it('fL.consignee'), // 收货人
            disabled: false,
            value: 'receiver_name',
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.consignee_phone'), // 收货人手机
            disabled: false,
            value: 'receiver_mobile',
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.consignee_tel'), // 收货人电话
            disabled: false,
            value: 'receiver_phone',
            width: '6',
          },
          {
            style: 'input',
            label: $it('fL.e7'), // 邮编
            disabled: false,
            value: 'receiver_zip',
            width: '6',
          },
          {
            style: "input",
            label: "买家留言",
            value: "BUYER_MESSAGE", // 买家留言
            disabled: true,
            width: "12",
          },
          {
            style: "input",
            label: "卖家备注",
            value: "SELLER_MEMO", // 卖家备注
            disabled: true,
            width: "12",
          },
        ],
        formValue: {
          receiver_address: '',
          cp_c_region_province_id: '',
          cp_c_region_city_id: '',
          cp_c_region_area_id: '',
          cp_c_region_town_ename: '',
          receiver_name: '',
          receiver_mobile: '',
          receiver_phone: '',
          receiver_zip: '',
          SELLER_MEMO: '',
          BUYER_MESSAGE: ''
        }
      },
      btnConfig: {
        typeAll: 'error', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('com.cancel'), // 取消
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            text: $it('com.determine'), // 确定
            btnclick: () => {
              this.update();
            },
          }
        ],
      },
    };
  },
  watch: {
    componentData: {
      handler(obj, oldval) {
        // 监测数据
        this.initAddress(obj);
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    initAddress(obj) {
      this.formConfig.formValue.cp_c_region_province_id = obj.CP_C_REGION_PROVINCE_ID;
      this.getCity();
      this.formConfig.formValue.cp_c_region_city_id = obj.CP_C_REGION_CITY_ID;
      this.getArea();
      if (obj) {
        for (let key in this.formConfig.formValue) {
          this.formConfig.formValue[key] = obj[key.toLocaleUpperCase()] || ''
        }
        this.formConfig.formData.forEach(i => {
          if (i.itemdata && i.itemdata.colname == 'cp_c_region_province_id') {
            i.itemdata.pid = obj.CP_C_REGION_PROVINCE_ID
            i.itemdata.valuedata = obj.CP_C_REGION_PROVINCE_ENAME
          }
          if (i.itemdata && i.itemdata.colname == 'cp_c_region_city_id') {
            i.itemdata.pid = obj.CP_C_REGION_CITY_ID
            i.itemdata.valuedata = obj.CP_C_REGION_CITY_ENAME
          }
          if (i.itemdata && i.itemdata.colname == 'cp_c_region_area_id') {
            i.itemdata.pid = obj.CP_C_REGION_AREA_ID
            i.itemdata.valuedata = obj.CP_C_REGION_AREA_ENAME
          }
        })
      }
    },
    async parseAddress() {
      if (this.newReceivAddress === '') return;
      this.parseAddressLoad = true;
      const result = parse(this.newReceivAddress);
      this.ReceivName = result.name;
      this.ReceivMobile = result.mobile;
      this.ReceivAddress = result.addr;
      this.ReceivTownName = result.town;
      this.ReceivAreaName = result.area;
      this.ReceivCityName = result.city;
      this.ReceivProvinceName = result.province;
      // 地址解析默认是正确状态
      this.dataAysis = true;
      // 判断省市区
      await this.intelligentAddress();
      // 判断是收货人基础信息是否正确
      await this.intelligentReciver();
      this.parseAddressLoad = true;
    },
    // 判断省市区是是否正确
    async intelligentAddress() {
      if (this.dataAysis) await this.searchProv();
      if (this.dataAysis) await this.searchCity();
      if (this.dataAysis) await this.searchArea();
    },
    async intelligentReciver() {
      if (!this.dataAysis) return;
      if (this.ReceivMobile) {
        const f = this.CheckRegx(this.regx.mobile, this.ReceivMobile);
        if (!f) return this.CheckRegxMobile();
      } else {
        return $fcError($it('tip.yi')); // 请填写收货人手机
      }
      if (this.ReceivName) {
        // let f = this.CheckRegx(this.regx.name, this.ReceivName);
        // if (!f) return this.CheckRegxName();
      } else {
        return $fcError($it('tip.yj')); // 请填写收货人名称
      }

      this.formConfig.formValue = {
        ...this.formConfig.formValue,
        cp_c_region_province_id: this.ReceivProvince,
        cp_c_region_city_id: this.ReceivCity,
        cp_c_region_area_id: this.ReceivArea,
        cp_c_region_town_ename: this.ReceivTown,
        receiver_name: this.ReceivName,
        receiver_mobile: this.ReceivMobile,
        receiver_address: this.ReceivAddress
      }
      this.formConfig.formData.forEach(i => {
        if (i.itemdata && i.itemdata.colname == 'cp_c_region_province_id') {
          i.itemdata.pid = this.ReceivProvince
          i.itemdata.valuedata = this.ReceivProvinceName
          i.itemdata.dropValue = [{ ID: this.ReceivProvince, Label: this.ReceivProvinceName }]
          i.itemdata.defaultSelectedMrp = [{ ID: this.ReceivProvince, Label: this.ReceivProvinceName }]
        }
        if (i.itemdata && i.itemdata.colname == 'cp_c_region_city_id') {
          i.itemdata.pid = this.ReceivCity
          i.itemdata.valuedata = this.ReceivCityName
          i.itemdata.dropValue = [{ ID: this.ReceivCity, Label: this.ReceivCityName }]
          i.itemdata.defaultSelectedMrp = [{ ID: this.ReceivCity, Label: this.ReceivCityName }]
        }
        if (i.itemdata && i.itemdata.colname == 'cp_c_region_area_id') {
          i.itemdata.pid = this.ReceivArea
          i.itemdata.valuedata = this.ReceivAreaName
          i.itemdata.dropValue = [{ ID: this.ReceivArea, Label: this.ReceivAreaName }]
          i.itemdata.defaultSelectedMrp = [{ ID: this.ReceivCity, Label: this.ReceivCityName }]
        }
      })
    },
    update() {
      const { cp_c_region_province_id, cp_c_region_city_id, cp_c_region_area_id, receiver_address,
        receiver_name, receiver_mobile, receiver_phone, receiver_zip
      } = this.formConfig.formValue
      if (!cp_c_region_province_id) {
        return $fcError($it('tip.yk')); // 请填写省份！
      }
      if (!cp_c_region_city_id) {
        return $fcError($it('tip.yl')); // 请填写城市！
      }
      if (!receiver_address) {
        return $fcError($it('tip.ym')); // 请填写详细地址！
      }
      //  f = this.CheckRegx(this.regx.name, receiver_name);
      // if (!f) return this.CheckRegxName();
      let f = this.CheckRegx(this.regx.mobile, receiver_mobile);
      if (this.componentData.ck != 50) {
        if (!f && receiver_mobile !== this.componentData.RECEIVER_MOBILE) return this.CheckRegxMobile();
      }
      // f = this.CheckRegx(this.regx.phone, receiver_phone);
      // if (!f) return this.CheckRegxPhone();
      if (receiver_zip) {
        f = this.CheckRegx(this.regx.shipzip, receiver_zip);
        if (!f) return this.CheckRegxZip();
      }
      if (!cp_c_region_area_id) {
        delete this.formConfig.formValue.cp_c_region_area_id;
      }
      delete this.formConfig.formValue.BUYER_MESSAGE;
      delete this.formConfig.formValue.SELLER_MEMO;
      const self = this;
      self.isShowFromLoading = true;
      const param = {
        id: self.componentData.ID,
        updateInfo: this.formConfig.formValue,
      };
      this.service.orderCenter.saveOrder(param).then((res) => {
        self.isShowFromLoading = false;
        self.isWatchChange = false;
        if (res.data.code === 0) {
          if (res.data.message) this.$Message.success(res.data.message);
          if (
            self.componentData.CALLBACK
            & (typeof self.componentData.CALLBACK === 'function')
          ) {
            self.componentData.CALLBACK();
          } else {
            try {
              self.$parent.$parent.$parent.autoRefresh();
            } catch (e) {
            }
          }
          self.$parent.$parent.closeConfirm();
        } else {
          $fcError(res.data.message);
        }
      });
    },
    /** 校验规则
     * s 字符串
     * reg  正则表达式
     */
    CheckRegx(reg, s) {
      return reg.test(s);
    },
    // CheckRegxName() {
    //   $fcError("收货人姓名不能为空,不能包含数字或者字符");
    // },
    CheckRegxMobile() {
      return $fcError($it('tip.yn')); // 收货人手机不合法
    },
    CheckRegxPhone() {
      return $fcError($it('tip.yo')); // 收货人电话不合法
    },
    CheckRegxZip() {
      return $fcError($it('tip.yp')); // 邮编不合法
    },
    searchProv() {
      const name = this.ReceivProvinceName;
      const obj = this.provList.find(
        item => item.ENAME === name
          || item.ENAME === `${name}市`
          || item.ENAME === `${name}省`
      );
      console.log(obj)
      if (obj) {
        this.ReceivProvince = obj.ID || '';
        // 查找城市
        return new Promise((resolve) => {
          this.getCity(resolve, this.ReceivProvince);
        });
      }
      $fcError($it('tip.yr')); // 请正确填写省份
      this.dataAysis = false;
    },
    searchCity() {
      const name = this.ReceivCityName || '';
      const obj = this.cityList.find(
        item => item.ENAME === name || item.ENAME === `${name}市`
      );
      if (obj) {
        this.ReceivCity = obj.ID;
        // 查找城市
        return new Promise((resolve) => {
          this.getArea(resolve, this.ReceivCity);
        });
      }
      $fcError($it('tip.ys')); // 请正确填写城市
      this.dataAysis = false;
    },
    searchArea() {
      const name = this.ReceivAreaName || '';
      const obj = this.areaList.find(
        item => item.ENAME === name || item.ENAME === `${name}区`
      );
      if (obj) {
        this.ReceivArea = obj.ID;
      } else {
        $fcError($it('tip.yt')); // 请正确填写区县
        this.dataAysis = false;
      }
    },
    async getProv() {
      const query = {
        ID: null,
        REGIONTYPE: 'COUN',
      };
      const res = await this.service.common.regionBySelect(query);
      // this.clearCity();
      if (res.data ? res.data.code === 0 : false) {
        this.provList = res.data.data.data.map(row => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
      } else {
        $fcError($it('tip.yu')); // 省份查询失败
      }
    },
    /** 回调
     *
     * callback
     * prov 省份
     */
    async getCity(callback, prov) {
      const provid = prov || this.formConfig.formValue.cp_c_region_province_id;
      // if (provid === "") return $fcError("请先选择省份");
      if (provid === '') return $fcError($it('tip.yv'));
      const query = {
        ID: provid,
        REGIONTYPE: 'PROV',
      };
      const res = await this.service.common.regionBySelect(query);
      if (res.data ? res.data.code === 0 : false) {
        this.cityList = res.data.data.data.map(row => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
        this.clearArea();
        // this.formConfig.formValue.cp_c_region_area_id = this.componentData.CP_C_REGION_AREA_ID;
      } else {
        $fcError($it('tip.yw')); // 城市查询失败
      }
      typeof callback === 'function' ? callback() : '';
    },
    async getArea(callback, city) {
      const cityid = city || this.formConfig.formValue.cp_c_region_city_id;
      console.log(this.formConfig.formValue, cityid)
      if (cityid === '') return $fcError($it('tip.yx')); // 请先选择城市
      const query = {
        ID: cityid,
        REGIONTYPE: 'CITY',
      };
      const res = await this.service.common.regionBySelect(query);
      if (res.data ? res.data.code === 0 : false) {
        this.areaList = res.data.data.data.map(row => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
      } else {
        $fcError($it('tip.yy')); // 区县查询失败
      }
      typeof callback === 'function' ? callback() : '';
    },
    clearProv(v) {
      if (this.parseAddressLoad === true) return;
      this.cityList = [];
      this.formConfig.formValue.cp_c_region_city_id = '';
      this.ReceivCity = '';
      this.clearCity();
      this.clearArea(true);
    },
    clearCity(v) {
      if (this.parseAddressLoad === true) return;
      this.areaList = [];
      this.formConfig.formValue.cp_c_region_area_id = '';
      this.ReceivArea = '';
      this.clearArea(true);
    },
    clearArea(isWatchChange, v) {
      isWatchChange !== undefined && (this.isWatchChange = true)
      if (this.isWatchChange) {
        this.formConfig.formValue.cp_c_region_town_ename = '';
        this.ReceivTown = '';
      }
    },
    onKeyDown(e) {
      if (this.$refs.newReceivAddress && this.$refs.newReceivAddress.$refs.input === document.activeElement) {
        return;
      }
      if (e.keyCode == 27) {
        this.$parent.$parent.closeConfirm();
      }
      if (e.keyCode == 13) {
        this.update();
      }
    },
    twoObjs(e) {
      console.log(e)
      const _this = this;
      _this.formConfig.formData.forEach((item) => {
        if (item.itemdata) {
          // 收货人省份
          if (item.itemdata.colname == 'cp_c_region_province_id' && item.itemdata.colname == e.colname) {
            this.formConfig.formValue.cp_c_region_province_id = item.itemdata.pid;
          } else if (item.itemdata.colname == 'cp_c_region_city_id' && item.itemdata.colname == e.colname) {
            // 收货人市
            this.formConfig.formValue.cp_c_region_city_id = item.itemdata.pid;
          } else if (item.itemdata.colname == 'cp_c_region_area_id' && item.itemdata.colname == e.colname) {
            // 收货人区
            this.formConfig.formValue.cp_c_region_area_id = item.itemdata.pid;
          }
        }
      });
    },
  },
  created() {
    // 获取所有省份的接口
    this.getProv();
    this.componentData = this.$store.state.customize.addressForOrderDetail
    this.objId = this.componentData.ID;
    this.initAddress(this.componentData);
  },
};
